/**
 * @prettier
 */

import { createRoutingAction } from 'utils/routing';

export const GoToSampling = createRoutingAction<{ appIdentifier: string }>('GO_TO_SAMPLING');
